module.exports = __webpack_public_path__ + "img/placeholder.da592c96.png";